import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { ConstantsService } from '../service/constants.service';

@Injectable({
  providedIn: 'root'
})
export class PlanVsActualService {

	constructor(private readonly http: HttpClient, private readonly constantsService: ConstantsService) { }

	loadRoute(updateObject): Observable<any> {
		return this.http.post(` ${this.constantsService.baseAPIURL}/eboi/planVSactual/getByRoute`, updateObject, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}
	loadPlant(updateObject): Observable<any> {
		return this.http.post(` ${this.constantsService.baseAPIURL}/eboi/planVSactual/getByPlant`, updateObject, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}
	loadSupplier(updateObject): Observable<any> {
		return this.http.post(` ${this.constantsService.baseAPIURL}/eboi/planVSactual/getBySupplier`, updateObject, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}
	loadDock(updateObject): Observable<any> {
		return this.http.post(` ${this.constantsService.baseAPIURL}/eboi/planVSactual/getByDock`, updateObject, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}
	
  private handleError(error: HttpErrorResponse) {
		return throwError(error.message || "Server Error");
	}

}
	